export default (props) => (
  <svg viewBox="0 0 290 290" fill="currentColor" {...props}>
    <title>...</title>
    <path d="M255 110a35 35 0 1 0 0 70 35 35 0 0 0 0-70zM35 110a35 35 0 1 0 0 70 35 35 0 0 0 0-70zM145 110a35 35 0 1 0 0 70 35 35 0 0 0 0-70z" />
  </svg>
);
